module.exports = __webpack_public_path__ + "media/images/menu-bg-m-5ccd8da380e111611a2c74aa8c658766.jpg";